import React, { useEffect } from 'react';
import { Box, Text, Heading, Button } from '@wix/design-system';
import { ChevronRight } from '@wix/wix-ui-icons-common';
import { useTranslation } from '@wix/wix-i18n-config';
import { useOrchestratorNavigation } from '@wix/gg-components/orchestrator';
import { Card } from '@wix/gg-components';
import { useResetStore } from 'stores/appStore';
import { useGTM } from '../../hooks/useGTM';
import WixLogo from 'assets/svgs/wix-logo.svg';
import styles from './WelcomeStep.scss';
import { getProviderConfig, getSubIdConfig } from 'config/providers';
import { Background } from 'components/App/Background';
import { WELCOME_VARIANTS } from './welcomeVariants';

export function WelcomeStep() {
  const { t } = useTranslation();
  const { next } = useOrchestratorNavigation();
  const resetStore = useResetStore();
  const { trackFunnelEntry } = useGTM();

  useEffect(() => {
    resetStore();
    trackFunnelEntry('welcome');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const subIdConfig = getSubIdConfig();
  const variant = subIdConfig?.experienceVariant ? WELCOME_VARIANTS[subIdConfig.experienceVariant] : undefined;

  const headingKey = variant?.headingKey ?? 'welcome.heading';
  const descriptionKey = variant?.descriptionKey ?? 'welcome.description';
  const ctaKey = variant?.ctaKey ?? 'welcome.cta';
  const Image = variant?.image ?? null;

  const LogoImage = getProviderConfig().logo;

  const logo = (
    <Box direction="horizontal" align="center" gap="16px" className={styles.logoContainer}>
      <WixLogo className={styles.logo} />
      {LogoImage && (
        <>
          <div className={styles.divider} />

          <div className={styles.aiBuilderLogoWrapper}>
            <LogoImage className={styles.aiBuilderLogo} />
          </div>
        </>
      )}
    </Box>
  );

  return (
    <div className={styles.wrapper}>
      <Background />
      <Card className={styles.card} contentClassName={styles.cardContent}>
        <Box direction="vertical" align="center" gap="40px">
          {logo}

          {Image && (
            <div className={styles.variantImage}>
              {typeof Image === 'string' ? <img src={Image} alt="" className={styles.variantImageImg} /> : <Image />}
            </div>
          )}
          <Box direction="vertical" align="center" gap="24px">
            <Heading size="extraLarge" align="center" className={styles.heading}>
              {t(headingKey)}
            </Heading>

            <Text size="medium" secondary align="center" className={styles.description}>
              {t(descriptionKey)}
            </Text>
          </Box>

          <Button size="large" onClick={next} skin="dark" suffixIcon={<ChevronRight />}>
            {t(ctaKey)}
          </Button>
        </Box>
      </Card>
    </div>
  );
}
